/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/prefer-default-export */

export const eventBus = {
  on<T = any>(event: string, callback: (data: T) => void) {
    document.addEventListener(event, ((e: CustomEvent<T>) => callback(e.detail)) as EventListener);
  },
  dispatch<T = any>(event: string, data: T) {
    document.dispatchEvent(new CustomEvent(event, { detail: data }));
  },
  remove<T = any>(event: string, callback: (data: T) => void) {
    document.removeEventListener(event, callback as unknown as EventListener);
  },
};
